import { getCategoryDetails } from "./";

export default state => getCategoryDetails(state)?.headerBody;
